import {
  ActivityIndicator,
  Dimensions,
  Modal,
  PixelRatio,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import MoneyIcon from "../../icons/MoneyIcon";
import Colours from "../../utils/Colours";
import VisaCardIcon from "../../icons/VisaCardIcon";
import TransferFromTable from "./TransferFromTable";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import PurchaseFromTable from "./PurchaseFromTable";
import useAuth from "../../hooks/useAuth";
import ErrorAlertComp from "../../alertComp/ErrorAlertComp";
import TableTrendDateSettings from "./TableTrendDateSettings";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const { width, height } = Dimensions.get("window");
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const SpendFromTable = ({
  hideScreen,
  useCaption,
  contributors,
  tableDataToUse,
  usePull,
  tableToUseID,
  showPurchaseFromTable,
  setShowPurchaseFromTable,
  useContributionAmount,
  showTransferFromTable,
  setShowTransferFromTable,
  showConfirmTransfer,
  setShowConfirmTransfer,
  showPaymentReceipt,
  setShowPaymentReceipt,

  showTheDoingsAmount,
  setShowTheDoingsAmount,
  showA_PartyHeatScreen,
  setShowA_PartyHeatScreen,
  showPartyHeatComp,
  setShowPartyHeatComp,

  successMessage,
  setSuccessMessage,

  hideAllPayScreens,
}) => {
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showPickATrendDate, setShowPickATrendDate] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedDateData, setSelectedDateData] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // const [showTransferFromTable, setShowTransferFromTable] = useState(false)

  const [activePattern, setActivePattern] = useState("");

  const { activitySettings } = useAuth();

  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    //console.log('selectedDateData', selectedDateData)
  }, [selectedDateData]);

  const scrollViewRef = useRef(null);

  const scrollToTop = () => {
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({ y: 0, animated: true });
    }
  };

  const handleSpendPattern = (pattern) => {
    setActivePattern(pattern);
  };

  const handleShowTrendDateNotice = () => {
    setShowPickATrendDate(true);
  };

  const isTrendDateSet = async () => {
    try {
      setIsLoading(true);

      const tableID = tableDataToUse?._id;

      const response = await axiosPrivate.get(`/isTrendDateSet/isTrendDateSet/${tableID}`);

      isDateSet = response.data.isTrendDateSet;

      //console.log('isDateSet', isDateSet)

      if (!isDateSet) {
        handleShowTrendDateNotice(true);
      } else {
        return isDateSet;
      }
    } catch (err) {
      //console.error("Error fetching trend date:");
    } finally {
      setIsLoading(false);
    }
  };

  const checkIfCanTransferByWeekend = async (tableID) => {
    setIsLoading(true);
    try {
      const response = await axiosPrivate.post("/canTransferWeekend/canTransferWeekend", {
        tableID: tableID,
      });

      return response.data.canTransfer; // returns true or false
    } catch (error) {
      console.log("Error checking transfer eligibility:", error);
      return false; // default to false if server fails
    } finally {
      setIsLoading(false);
    }
  };

  const handleChoose = async () => {
    //setIsButtonClicked(true)
    //console.log('activePattern', activePattern)
    const tableID = tableDataToUse?._id;

    if (activePattern === "transfer") {
      const canTransferFunds = await checkIfCanTransferByWeekend(tableID); // <--- add this line

      if (!canTransferFunds) {
        setErrorMessage("Transfer allowed only when your set weekend starts.");
        setShowErrorAlert(true);
        return;
      }
      if (!activitySettings.canTableTransfer) {
        setErrorMessage(
          "Fund transfer through tables is not available at the moment, please try again later"
        );
        setShowErrorAlert(true);
        return;
      }

      //check wether trenddate is set
      const dateSet = await isTrendDateSet();

      if (dateSet) {
        setShowTransferFromTable(true);
      }

      // handleShowTrendDateNotice(true)
    } else if (activePattern === "purchase") {
      //console.log('Purchase')
      const dateSet = await isTrendDateSet();
      //  handleShowTrendDateNotice(true)
      if (dateSet) {
        setShowPurchaseFromTable(true);
      }
    } else {
      //console.log('Please select an active pattern')
    }
    //   hideScreen()
  };

  return (
    <View>
      <View style={styles.paymentMethodStyle}>
        <Text style={styles.useCaptionTxt}>{useCaption}</Text>
        <View style={styles.dataContainer2}>
          <View style={styles.dataSubContainer}>
            <MoneyIcon
              color={Colours.PRIMARY_LIGHT}
              height={dynamicSize(30)}
              width={dynamicSize(30)}
            />
            <View style={styles.captionAndDescribtion}>
              <View style={styles.flatArrowContainer}>
                <Text style={styles.moneyOnTableTxt}>Money on the table: </Text>
                <Text style={styles.moneyAmtTxt}>{useContributionAmount} </Text>
                {/* <FowardFlatArrow color={Colours.PRIMARY} /> */}
              </View>
            </View>
          </View>
        </View>
      </View>

      <View style={styles.paymentMethodStyle}>
        <TouchableOpacity
          style={[
            styles.dataContainer2,
            { borderColor: activePattern === "transfer" ? Colours.PRIMARY : Colours.LIGHTGRAY },
          ]}
          onPress={() => handleSpendPattern("transfer")}
        >
          <View style={styles.dataSubContainer}>
            {/* <MoneyIcon color={activeMethod === 'wallet' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY} height={25} width={25} /> */}
            <View style={styles.captionAndDescribtion}>
              <View style={styles.flatArrowContainer}>
                <Text
                  style={{
                    color: activePattern === "transfer" ? Colours.PRIMARY : Colours.DARKLIGHTGRAY,
                    fontSize: dynamicFontSize(14),
                    fontFamily: "Sen-Regular",
                  }}
                >
                  Transfer fund{" "}
                </Text>
                {/* <Text style={{ color: activePattern === 'transfer' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>Transfer funds or Make Reservations through money transfer </Text> */}

                {/* <FowardFlatArrow color={Colours.PRIMARY} /> */}
              </View>
            </View>
          </View>
        </TouchableOpacity>

        <TouchableOpacity
          style={[
            styles.dataContainer2,
            { borderColor: activePattern === "purchase" ? Colours.PRIMARY : Colours.LIGHTGRAY },
          ]}
          // onPress={() => handleSpendPattern('purchase')}
          onPress={() => {}}
        >
          <View style={styles.dataSubContainer}>
            {/* <VisaCardIcon color={activeMethod === 'card' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY} height={25} width={25} /> */}
            <View style={styles.captionAndDescribtion}>
              <View style={styles.flatArrowContainer}>
                {/* <Text style={{ color: activePattern === 'purchase' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>Gain access to our partner nightclubs, lounges, shows, parties, and experiences. Access may include table reservations, ticket purchases or check-ins. </Text> */}
                {/* <Text style={{ color: activePattern === 'purchase' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>Make Reservations with our partner nightclubs, resturants and lounge </Text> */}
                {/* <Text style={{ color: activePattern === 'purchase' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>Gain access to our partner nightclubs, lounges ,resturants and shows. Access may include table reservations, ticket purchases or check-ins. </Text> */}
                <Text
                  style={{
                    color: activePattern === "purchase" ? Colours.PRIMARY : Colours.DARKLIGHTGRAY,
                    fontSize: dynamicFontSize(14),
                    fontFamily: "Sen-Regular",
                  }}
                >
                  ***
                </Text>

                {/* <FowardFlatArrow color={Colours.PRIMARY} /> */}
              </View>
            </View>
          </View>
        </TouchableOpacity>

        <TouchableOpacity
          style={[
            styles.buttonGray,
            { backgroundColor: isButtonClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
          ]}
          onPress={() => handleChoose()}
          disabled={isLoading}
        >
          {isLoading ? (
            <ActivityIndicator size="small" color={Colours.PRIMARY} /> // spinner instead of text
          ) : (
            <Text style={styles.proceedTxt}>Proceed</Text>
          )}
        </TouchableOpacity>
      </View>

      <Modal
        animationType="fade"
        visible={showTransferFromTable}
        onRequestClose={() => setShowTransferFromTable(false)}
      >
        <TopHeaderComponent
          headerText={"Transfer From Table"}
          hideScreen={() => setShowTransferFromTable(false)}
        />
        <ScrollView
          ref={scrollViewRef}
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <View style={styles.componentStyle}>
            <TransferFromTable
              scrollToTop={scrollToTop}
              useCaption={useCaption}
              tableToUseID={tableToUseID}
              useContributionAmount={useContributionAmount}
              showConfirmTransfer={showConfirmTransfer}
              setShowConfirmTransfer={setShowConfirmTransfer}
              showPaymentReceipt={showPaymentReceipt}
              setShowPaymentReceipt={setShowPaymentReceipt}
              hideAllPayScreens={hideAllPayScreens}
            />
          </View>
        </ScrollView>
      </Modal>

      <Modal
        animationType="fade"
        visible={showPurchaseFromTable}
        onRequestClose={() => setShowPurchaseFromTable(false)}
      >
        <TopHeaderComponent
          headerText={"Access"}
          hideScreen={() => setShowPurchaseFromTable(false)}
        />
        <ScrollView
          ref={scrollViewRef}
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <View style={styles.componentStyle}>
            <PurchaseFromTable
              scrollToTop={scrollToTop}
              useCaption={useCaption}
              tableToUseID={tableToUseID}
              contributors={contributors}
              usePull={usePull}
              useContributionAmount={useContributionAmount}
              tableDataToUse={tableDataToUse}
              showTheDoingsAmount={showTheDoingsAmount}
              setShowTheDoingsAmount={setShowTheDoingsAmount}
              showA_PartyHeatScreen={showA_PartyHeatScreen}
              setShowA_PartyHeatScreen={setShowA_PartyHeatScreen}
              showPartyHeatComp={showPartyHeatComp}
              setShowPartyHeatComp={setShowPartyHeatComp}
              successMessage={successMessage}
              setSuccessMessage={setSuccessMessage}
              hideAllPayScreens={hideAllPayScreens}
            />
          </View>
        </ScrollView>
      </Modal>

      <Modal
        visible={showPickATrendDate}
        animationType="fade"
        onRequestClose={() => setShowPickATrendDate(false)}
      >
        <TopHeaderComponent
          headerText={"Doings Trend"}
          hideScreen={() => setShowPickATrendDate(false)}
        />
        <ScrollView
          // ref={scrollViewRef}
          contentContainerStyle={{
            flexGrow: 1,
            paddingBottom: 100,
            backgroundColor: Colours.LIGHTEST,
          }}
        >
          <View style={styles.componentStyle}>
            <TableTrendDateSettings
              setSelectedDateData={setSelectedDateData}
              tableDataToUse={tableDataToUse}
              hideModal={() => {
                setShowPickATrendDate(false);
                if (activePattern === "transfer") {
                  setShowTransferFromTable(true);
                } else {
                  setShowPurchaseFromTable(true);
                }
              }}
            />
          </View>
        </ScrollView>
      </Modal>

      <Modal visible={showErrorAlert} animationType="fade" transparent={true}>
        <ErrorAlertComp
          message={errorMessage}
          onClose={() => {
            setShowErrorAlert(false);
          }}
        />
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  paymentMethodStyle: {
    display: "flex",
    justifyContent: "center",
    margin: dynamicSpacing(15),
    marginBottom: dynamicSpacing(4),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(15),
    backgroundColor: "white",
    shadowColor: "#E8E8E8",
  },
  useCaptionTxt: {
    marginBottom: dynamicSpacing(10),
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  moneyOnTableTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Regular",
  },
  moneyAmtTxt: {
    color: Colours.PRIMARY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Bold",
  },
  proceedTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(17),
    fontFamily: "Sen-Bold",
  },
  dataContainer2: {
    display: "flex",
    borderWidth: 1,
    borderColor: Colours.PRIMARY_LIGHTER,
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  dataContainer: {
    display: "flex",
    backgroundColor: "white",
    margin: dynamicSpacing(10),
    marginTop: dynamicSpacing(15),
    padding: dynamicSpacing(15),
    borderRadius: dynamicSize(10),
    marginBottom: dynamicSpacing(10),
  },
  dataSubContainer2: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
    marginBottom: dynamicSpacing(10),
  },
  dataSubContainer: {
    display: "flex",
    flexDirection: "row",
    gap: dynamicSpacing(10),
    alignItems: "center",
  },
  flatArrowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  captionAndDescribtion: {
    display: "flex",
  },
  buttonGray: {
    display: "flex",
    borderRadius: dynamicSize(10),
    justifyContent: "center",
    marginTop: dynamicSpacing(10),
    alignItems: "center",
    height: dynamicSize(55),
    width: "100%",
    backgroundColor: Colours.DARKGRAY,
  },
});

export default SpendFromTable;
